class PromoTicker {
  constructor(container) {
    // Store container and find all messages
    this.container = container;
    this.messages = Array.from(container.querySelectorAll('.promo-ticker__message'));
    
    // Only initialize if we have messages
    if (this.messages.length > 0) {
      this.currentIndex = 0;
      this.autoplaySpeed = parseInt(container.dataset.autoplaySpeed, 10) || 5000;
      
      // Show first message immediately
      this.showMessage(0);
      
      // Start rotation after a brief delay
      setTimeout(() => {
        this.startRotation();
      }, 100);
    }
  }
  
  showMessage(index) {
    // Remove active class from all messages
    this.messages.forEach(msg => {
      msg.classList.remove('active');
    });
    
    // Add active class to current message
    this.messages[index].classList.add('active');
  }
  
  startRotation() {
    this.interval = setInterval(() => {
      // Calculate next index
      this.currentIndex = (this.currentIndex + 1) % this.messages.length;
      
      // Show next message
      this.showMessage(this.currentIndex);
    }, this.autoplaySpeed);
  }
}

// Function to initialize all tickers
function initPromoTickers() {
  const tickers = document.querySelectorAll('.promo-ticker');
  tickers.forEach(ticker => {
    new PromoTicker(ticker);
  });
}

// For theme editor
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.dataset.sectionType === 'promo-ticker') {
      new PromoTicker(event.target);
    }
  });
}

// Initialize on page load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPromoTickers);
} else {
  initPromoTickers();
}